export default __webpack_public_path__ + "static/media/intern_qr_2.07058e8f.png";